/* Ellementree — progressive enhancement only.
   Every page works with this file blocked. */

(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------- mobile nav */
  var menuBtn = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      var open = mobileNav.getAttribute('data-open') === 'true';
      mobileNav.setAttribute('data-open', String(!open));
      menuBtn.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ----------------------------------------------------- sticky header
     The header rule only earns its line once content is behind it. */
  var header = document.querySelector('.header');
  if (header) {
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px';
    header.parentNode.insertBefore(sentinel, header);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        header.setAttribute('data-stuck', String(!entries[0].isIntersecting));
      }).observe(sentinel);
    }
  }

  /* -------------------------------------------------------- accordions
     Height animates through a grid track, so a fast double-toggle
     retargets instead of restarting. The panel is only hidden from
     assistive tech while it is fully closed. */
  document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;

    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      panel.setAttribute('data-open', String(!expanded));
    });
  });

  /* ---------------------------------------------------- option groups
     Roving state on a radiogroup, with arrow keys as well as clicks. */
  document.querySelectorAll('[data-option-group]').forEach(function (group) {
    var options = Array.prototype.slice.call(
      group.querySelectorAll('[data-option-value]')
    );

    function select(button) {
      options.forEach(function (other) {
        var on = other === button;
        other.setAttribute('aria-checked', String(on));
        other.tabIndex = on ? 0 : -1;
      });
      var input = document.querySelector(group.getAttribute('data-option-target'));
      if (input) {
        input.value = button.getAttribute('data-option-value');
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var readout = group.parentNode.querySelector('[data-option-readout]');
      if (readout) readout.textContent = button.getAttribute('data-option-value');
    }

    options.forEach(function (option) {
      option.tabIndex = option.getAttribute('aria-checked') === 'true' ? 0 : -1;
      option.addEventListener('click', function () { select(option); });
    });

    group.addEventListener('keydown', function (event) {
      var i = options.indexOf(document.activeElement);
      if (i === -1) return;
      var next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = i + 1;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = i - 1;
      if (next === null) return;
      event.preventDefault();
      var target = options[(next + options.length) % options.length];
      target.focus();
      select(target);
    });
  });

  /* --------------------------------------------------- gallery counter
     On the mobile swipe strip the buyer needs to know there is more
     than one frame. Desktop hides this in CSS. */
  var gallery = document.querySelector('.product__gallery');
  var counter = document.querySelector('[data-gallery-count]');
  if (gallery && counter) {
    var frames = gallery.children.length;
    gallery.addEventListener('scroll', function () {
      var i = Math.round(gallery.scrollLeft / gallery.clientWidth) + 1;
      counter.textContent = Math.min(Math.max(i, 1), frames) + ' / ' + frames;
    }, { passive: true });
  }

  /* ------------------------------------------------------------- wipe
     The one authored moment. Photography wipes up from its own bottom
     edge, staggered across a row so a grid arrives as a sequence rather
     than a flash. Anything already on screen at load is shown at once,
     because an entrance for something the visitor is already looking at
     is just a delay. */
  var wipes = document.querySelectorAll('[data-wipe]');

  if (reduce || !('IntersectionObserver' in window)) {
    wipes.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  var firstPaint = true;
  var observer = new IntersectionObserver(function (entries) {
    var arriving = entries.filter(function (e) { return e.isIntersecting; });

    arriving.forEach(function (entry, i) {
      // 45ms reads as a cascade; past ~80ms it reads as a queue.
      var delay = firstPaint ? 0 : Math.min(i, 5) * 45;
      entry.target.style.setProperty('--wipe-delay', delay + 'ms');
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });

    if (arriving.length) firstPaint = false;
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });

  wipes.forEach(function (el) { observer.observe(el); });
})();

/* ------------------------------------------------------- guide dialog
   Progressive enhancement, deliberately: the link points at a real page
   and keeps working with JavaScript off, in a new tab, or in a crawler.
   With JavaScript we intercept it and pull the same page into a dialog,
   so checking a measurement never costs you the size you had selected. */
(function () {
  var supported = typeof window.HTMLDialogElement === 'function' && 'fetch' in window;
  if (!supported) return;

  var dialog = null;
  var cache = {};

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'guide-dlg';
    dialog.innerHTML =
      '<div class="guide-dlg__bar">' +
        '<span class="guide-dlg__title" data-guide-title></span>' +
        '<button type="button" class="guide-dlg__x" data-guide-close aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="guide-dlg__body prose" data-guide-body tabindex="-1"></div>';
    document.body.appendChild(dialog);

    // Clicking the backdrop is the same gesture as clicking away from it.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.querySelector('[data-guide-close]').addEventListener('click', function () {
      dialog.close();
    });
  }

  function extract(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var content = parsed.querySelector('#main .prose');
    return content ? content.innerHTML : '';
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a.field__guide');
    if (!link) return;
    // Let people who want a real tab still have one.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    event.preventDefault();
    if (!dialog) build();

    var url = link.getAttribute('href');
    var body = dialog.querySelector('[data-guide-body]');
    dialog.querySelector('[data-guide-title]').textContent = link.textContent.trim();

    if (cache[url]) {
      body.innerHTML = cache[url];
      dialog.showModal();
      body.scrollTop = 0;
      return;
    }

    body.innerHTML = '';
    dialog.showModal();

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        cache[url] = extract(html);
        body.innerHTML = cache[url];
        body.scrollTop = 0;
      })
      .catch(function () {
        // Never strand anyone in an empty box.
        body.innerHTML = '<p><a href="' + url + '">Open the full guide</a></p>';
      });
  });
})();
